export const environment = {
  production: false,
  apiUrl: '/event-manager',
};
